import { RunRow } from "@features/scenarioDesign/RunTable"
import { IconButton, Typography } from "@mui/material"
import { RunStatusDto } from "@store/services/runService"
import { MRT_Row } from "material-react-table"
import FileOpenIcon from "@mui/icons-material/FileOpen"
import FindInPageIcon from "@mui/icons-material/FindInPage"
import { useNavigate } from "react-router"
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning"
import { getEligibleSupportContractOptions } from "@features/run/RunModelForm/helpers"
import { useAtomValue } from "jotai"
import { permissionsAtom } from "@store/authAtoms"

const ActionsCell = ({ row }: { row: MRT_Row<RunRow> }) => {
  const permissions = useAtomValue(permissionsAtom)
  const navigate = useNavigate()

  // TODO KK: use actual links instead of redirecting by click handler
  return (
    <>
      {row.original.status === RunStatusDto.DONE && (
        <IconButton
          sx={{ borderRadius: "5%" }}
          onClick={() =>
            navigate(
              `/Results/Result/${row.original.run_key}?graphKey=${encodeURIComponent(
                row.original.base_graph_key,
              )}`,
            )
          }
        >
          <>
            <FileOpenIcon />
            <Typography>Results</Typography>
          </>
        </IconButton>
      )}

      {![RunStatusDto.ERROR, RunStatusDto.TIMEOUT, RunStatusDto.DONE].includes(
        row.original.status,
      ) && (
        <IconButton
          sx={{ borderRadius: "5%" }}
          onClick={() => navigate(`/Run/Progress/${row.original.run_key}`)}
        >
          <>
            <FindInPageIcon />
            <Typography>Check status</Typography>
          </>
        </IconButton>
      )}
      {(getEligibleSupportContractOptions(row.original.family, permissions).length >= 1 ||
        row.original.is_creator_and_private) &&
        row.original.model_key && (
          <IconButton
            sx={{ borderRadius: "5%" }}
            onClick={() => navigate(`/Run/ViewModel/${row.original.model_key}`)}
          >
            <>
              <EscalatorWarningIcon />
              <Typography>Diagnose</Typography>
            </>
          </IconButton>
        )}
    </>
  )
}

export default ActionsCell
